import React from 'react'

const BuildingIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3614_29838)">
        <path d="M4.47363 14.3381V2.86115C4.47363 2.52294 4.60799 2.19859 4.84713 1.95944C5.08628 1.72029 5.41064 1.58594 5.74885 1.58594H10.8497C11.1879 1.58594 11.5123 1.72029 11.7514 1.95944C11.9906 2.19859 12.1249 2.52294 12.1249 2.86115V14.3381H4.47363Z" stroke="#FF0B0B" strokeWidth="1.27521" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.47426 7.95312H3.19904C2.86083 7.95312 2.53648 8.08748 2.29733 8.32663C2.05818 8.56578 1.92383 8.89013 1.92383 9.22834V13.054C1.92383 13.3922 2.05818 13.7165 2.29733 13.9557C2.53648 14.1948 2.86083 14.3292 3.19904 14.3292H4.47426" stroke="#FF0B0B" strokeWidth="1.27521" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.125 6.04688H13.4002C13.7384 6.04688 14.0628 6.18123 14.3019 6.42038C14.5411 6.65953 14.6754 6.98388 14.6754 7.32209V13.0606C14.6754 13.3988 14.5411 13.7231 14.3019 13.9623C14.0628 14.2014 13.7384 14.3358 13.4002 14.3358H12.125" stroke="#FF0B0B" strokeWidth="1.27521" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.02441 4.13281H9.57484" stroke="#FF0B0B" strokeWidth="1.27521" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.02441 6.67969H9.57484" stroke="#FF0B0B" strokeWidth="1.27521" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.02441 9.23438H9.57484" stroke="#FF0B0B" strokeWidth="1.27521" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.02441 11.7812H9.57484" stroke="#FF0B0B" strokeWidth="1.27521" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_3614_29838">
          <rect width="15.3026" height="15.3026" fill="white" transform="translate(0.648438 0.304688)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default BuildingIcon
